var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { loading } from 'elements/Loading';
import { Button, FieldType } from 'elements';
import { rules } from 'helpers/Validation';
import StretchesFormulario from './StretchesFormulario';
import { toMoney, toStringNumber } from '../../../helpers/Format';
import { T as Traduce } from '../../../helpers/i18n';
import history from '../../../helpers/History';
var StretchesForm = /** @class */ (function (_super) {
    __extends(StretchesForm, _super);
    function StretchesForm() {
        var _this = this;
        var _a;
        _this = _super.apply(this, arguments) || this;
        _this.priceFields = _this.props.passengerCategories.filter(function (pc) { return !pc.disabled_at; }).map(function (item) {
            // console.log('item', item)
            var prices = _this.props.stretch ? _this.props.stretch.prices : [];
            var esquema = {};
            prices.forEach(function (priceItem) {
                esquema[priceItem.passengerCategory_id.toString()] = priceItem.price;
            });
            // console.log('esquema', esquema)
            return {
                name: item.name,
                type: FieldType.Text,
                rules: rules().number(),
                size: 2,
                id: item.id,
                value: esquema[item.id]
            };
        });
        _this.collaboratorPriceFields = function (vuelta) {
            var _a;
            var result = {};
            // si estoy creando un servicio no permito añadir precios a los afiliados
            if (!_this.props.stretch) {
                return {};
            }
            (_a = _this.props.collaborators) === null || _a === void 0 ? void 0 : _a.forEach(function (collaborator) {
                var _a, _b;
                // compruebo si está en collaboratorPrices el colaborador
                var prices;
                if (!vuelta) {
                    prices = ((_a = _this.props.stretch.collaboratorPrices) === null || _a === void 0 ? void 0 : _a.filter(function (collaboratorPrice) {
                        return collaboratorPrice.collaborator_id === collaborator.id &&
                            !collaboratorPrice.idaVuelta;
                    })) || [];
                }
                else {
                    prices = ((_b = _this.props.stretch.collaboratorPrices) === null || _b === void 0 ? void 0 : _b.filter(function (collaboratorPrice) {
                        return collaboratorPrice.collaborator_id === collaborator.id && collaboratorPrice.idaVuelta;
                    })) || [];
                }
                result[collaborator.id] = _this.props.passengerCategories.map(function (passengerCategory) {
                    // si tiene valor la categoría le asigno priceNet, caso contrario asigno undefined
                    var price = prices.find(function (_price) { return _price.passengerCategory_id === passengerCategory.id; });
                    return {
                        name: passengerCategory.name,
                        type: FieldType.Text,
                        rules: rules().number(),
                        size: 2,
                        id: passengerCategory.id,
                        value: price ? price.priceNet : undefined
                    };
                });
            });
            // console.log('collaboratorPriceFields - result: ', result)
            return result;
        };
        _this.afiliatePriceFields = function (vuelta) {
            var _a;
            var result = {};
            // si estoy creando un servicio no permito añadir precios a los afiliados
            if (!_this.props.stretch) {
                return {};
            }
            (_a = _this.props.afiliates) === null || _a === void 0 ? void 0 : _a.forEach(function (afiliate) {
                var _a, _b;
                // compruebo si está en afiliatePrices el afiliado
                var prices;
                if (!vuelta) {
                    prices = ((_a = _this.props.stretch.afiliatePrices) === null || _a === void 0 ? void 0 : _a.filter(function (afiliatePrice) {
                        return afiliatePrice.afiliate_id === afiliate.id &&
                            !afiliatePrice.idaVuelta;
                    })) || [];
                }
                else {
                    prices = ((_b = _this.props.stretch.afiliatePrices) === null || _b === void 0 ? void 0 : _b.filter(function (afiliatePrice) {
                        return afiliatePrice.afiliate_id === afiliate.id && afiliatePrice.idaVuelta;
                    })) || [];
                }
                result[afiliate.id] = _this.props.passengerCategories.map(function (passengerCategory) {
                    // si tiene valor la categoría le asigno priceNet, caso contrario asigno undefined
                    var price = prices.find(function (_price) { return _price.passengerCategory_id === passengerCategory.id; });
                    return {
                        name: passengerCategory.name,
                        type: FieldType.Text,
                        rules: rules().number(),
                        size: 2,
                        id: passengerCategory.id,
                        value: price ? price.priceNet : undefined
                    };
                });
            });
            // console.log('afiliatePriceFields - result: ', result)
            return result;
        };
        _this.vueltaPriceFields = _this.props.passengerCategories.map(function (item) {
            // console.log('item', item)
            var vueltaPrices = _this.props.stretch
                ? _this.props.stretch.vueltaPrices
                    ? _this.props.stretch.vueltaPrices
                    : []
                : [];
            var esquema = {};
            vueltaPrices.forEach(function (priceItem) {
                esquema[priceItem.passengerCategory_id] = priceItem.price;
            });
            // console.log('esquema', esquema)
            return {
                name: item.name,
                type: FieldType.Text,
                rules: rules().number(),
                size: 2,
                id: item.id,
                value: esquema[item.id]
            };
        });
        _this.operations = _this.props.operationLines
            ? _this.props.operationLines
            : [];
        _this.operationsMapeados = _this.operations.map(function (item) {
            // console.log('item', item)
            return {
                value: String(item.id),
                name: item.name
            };
        });
        _this.operationsOptions = !_this.props.stretch
            ? __spreadArray([{ value: '0', name: '' }], _this.operationsMapeados, true) : _this.operationsMapeados;
        /*private vehicles = this.props.vehicles?? []
        private vehiclesMapeados = this.vehicles.map(item => {
          return {
            value: String(item.id),
            name: `${Traduce('name')} ` + item.name + `; ${Traduce('id')} ` + item.code + `; ${Traduce('type')} ` + item.typeVehicle + `; ${Traduce('capacity')} ` + item.capacity
          }
        })
        private vehiclesOptions = this.vehiclesMapeados*/
        _this.headboards = _this.props.headboards ? _this.props.headboards : [];
        _this.headboardsMapeados = _this.headboards.map(function (item) {
            return {
                value: String(item.id),
                name: item.name
            };
        });
        _this.headboardsOptions = __spreadArray([
            { value: null, name: '' }
        ], _this.headboardsMapeados, true);
        _this.receiptLayouts = ((_a = _this.props.receiptLayouts) === null || _a === void 0 ? void 0 : _a.length) > 0 ? _this.props.receiptLayouts.filter(function (item) { return item.type === 'ticket'; })
            : [];
        _this.receiptLayoutsMapeados = _this.receiptLayouts.map(function (item) { return ({
            value: String(item.id),
            name: item.name
        }); });
        _this.receiptLayoutsOptions = __spreadArray([], _this.receiptLayoutsMapeados, true);
        _this.horasIda = _this.props.schedules ? _this.props.schedules : [];
        _this.horasIdaMapeados = _this.horasIda.map(function (schedule) {
            return {
                id: schedule.id,
                value: String(schedule.id),
                name: "".concat(toStringNumber(schedule.hours), ":").concat(toStringNumber(schedule.minutes)),
                selected: _this.props.stretch &&
                    _this.props.stretch.horasIda &&
                    _this.props.stretch.horasIda.findIndex(function (element) { return element.id === schedule.id; }) !== -1
            };
        });
        _this.horasIdaOptions = !_this.props.stretch
            ? __spreadArray([], _this.horasIdaMapeados, true) : _this.horasIdaMapeados;
        _this.extras = _this.props.extras || [];
        _this.extrasMapeados = _this.extras.map(function (extra) {
            // console.log('extra: ', extra)
            // console.log('this.props.stretch.extras: ', this.props.stretch.extras)
            var selected = _this.props.stretch &&
                _this.props.stretch.extras &&
                _this.props.stretch.extras.findIndex(function (element) { return Number(element.id) === extra.id; }) !== -1;
            var money = _this.props.stretch && _this.props.stretch.primaryMoney
                ? _this.props.stretch.primaryMoney.alphabeticCode
                : _this.props.money.alphabeticCode;
            var priceWithTax = toMoney(extra.price * extra.tax.value + extra.price, money);
            return {
                value: String(extra.id),
                name: "".concat(extra.name, " - ").concat(priceWithTax),
                selected: selected
            };
        });
        _this.extrasOptions = !_this.props.extras
            ? __spreadArray([{ value: '0', name: '' }], _this.extrasMapeados, true) : _this.extrasMapeados;
        _this.horasVuelta = _this.props.schedules ? _this.props.schedules : [];
        _this.horasVueltaMapeados = _this.horasIda.map(function (schedule) {
            return {
                value: String(schedule.id),
                name: "".concat(toStringNumber(schedule.hours), ":").concat(toStringNumber(schedule.minutes)),
                selected: _this.props.stretch &&
                    _this.props.stretch.horasVuelta &&
                    _this.props.stretch.horasVuelta.findIndex(function (element) { return element.id === schedule.id; }) !== -1
            };
        });
        _this.horasVueltaOptions = !_this.props.stretch
            ? __spreadArray([{ value: '0', name: '' }], _this.horasVueltaMapeados, true) : _this.horasVueltaMapeados;
        _this.taxes = _this.props.taxes ? _this.props.taxes : [];
        _this.taxesMapeados = _this.taxes.map(function (item) {
            // console.log('item', item)
            return {
                value: String(item.id),
                name: item.name
            };
        });
        _this.taxesOptions = !_this.props.stretch
            ? __spreadArray([{ value: '0', name: '' }], _this.taxesMapeados, true) : _this.taxesMapeados;
        _this.fields = [
            {
                name: 'name',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    // .alphaDashSpace()
                    .required(),
                size: 6,
                tooltip: 'name'
            },
            {
                name: 'code',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required(),
                size: 4
            },
            {
                name: 'origin',
                type: FieldType.Text,
                rules: rules().string(),
                size: 5
            },
            {
                name: 'destination',
                type: FieldType.Text,
                rules: rules().string(),
                size: 5
            },
            {
                name: 'tax',
                column: 'tax_id',
                type: FieldType.Select,
                rules: rules()
                    .number()
                    .integer()
                    .required(),
                options: _this.taxesOptions,
                size: 3
            },
            {
                name: 'operationline',
                column: 'operationLine_id',
                type: FieldType.Select,
                rules: rules()
                    .number()
                    .integer()
                    .required(),
                options: _this.operationsOptions,
                size: 3
            },
            {
                name: 'receiptLayout',
                column: 'receiptLayout_id',
                type: FieldType.Select,
                rules: rules()
                    .number()
                    .integer()
                    .required(),
                defaultValue: 1,
                options: _this.receiptLayoutsOptions,
                size: 3
            },
            {
                name: 'cabeceraTicket',
                column: 'headboard_id',
                type: FieldType.Select,
                options: _this.headboardsOptions,
                size: 4
            },
            {
                name: 'printPrice',
                type: FieldType.Checkbox,
                rules: rules().boolean(),
                size: 2,
                defaultValue: true,
                tooltipId: 'printPrice',
                tooltip: Traduce('printPriceTicket')
            },
            {
                name: 'unitary',
                type: FieldType.Checkbox,
                rules: rules().boolean(),
                size: 2,
                defaultValue: false,
                tooltipId: 'unitary',
                tooltip: Traduce('unitaryTooltip')
            },
            {
                name: 'tramoHora',
                type: FieldType.Checkbox,
                rules: rules().boolean(),
                size: 10,
                defaultValue: true,
                tooltipId: 'tramoHora',
                tooltip: Traduce('serviceWithHourUse')
            },
            {
                name: 'horasIda',
                column: 'horasIda',
                type: FieldType.ToggleSelect,
                multiple: true,
                options: _this.horasIdaOptions,
                tooltipId: 'horasIda',
                tooltip: Traduce('departureTime'),
                size: 9
            },
            {
                name: 'extras',
                type: FieldType.MultiSelect,
                options: _this.extrasOptions,
                tooltipId: 'extras',
                tooltip: Traduce('extras'),
                size: 10
            },
            {
                name: 'transferService',
                type: FieldType.Checkbox,
                rules: rules().boolean(),
                size: 2,
                defaultValue: false,
                tooltipId: 'transferService',
                tooltip: Traduce('transferServiceTooltip')
            },
            {
                name: 'hoponHopoff',
                type: FieldType.Checkbox,
                rules: rules().boolean(),
                size: 2,
                defaultValue: false,
                tooltipId: 'hoponHopoff',
                tooltip: 'Ticket HopON HopOFF'
            },
            {
                name: 'vuelta',
                type: FieldType.Checkbox,
                rules: rules().boolean(),
                size: 2,
                defaultValue: false,
                tooltipId: 'vuelta',
                tooltip: 'Para dos usos, uno de ida y otro de vuelta dentro del tiempo de validez'
            },
            {
                name: 'timeAdvance',
                type: FieldType.Number,
                rules: rules()
                    .number()
                    .integer(),
                defaultValue: 0,
                size: 3,
                tooltipId: 'timeAdvance',
                tooltip: Traduce('timeBeforeValidateTicket')
            },
            {
                name: 'timeDelay',
                type: FieldType.Number,
                rules: rules()
                    .number()
                    .integer(),
                defaultValue: 0,
                size: 3,
                tooltipId: 'timeDelay',
                tooltip: Traduce('timeAfterValidateTicket')
            },
            {
                name: 'timeExpiration',
                column: 'timeExpiration',
                type: FieldType.Number,
                rules: rules()
                    .number()
                    .integer(),
                defaultValue: 0,
                size: 3,
                /*tooltip: 'Ticket válido durante .... (días). "0" para el resto del día actual'*/
                tooltipId: 'timeExpiration',
                tooltip: Traduce('timeFirstValidateTicket')
            },
            {
                name: 'timeUse',
                column: 'timeUse',
                type: FieldType.Number,
                rules: rules()
                    .number()
                    .integer(),
                defaultValue: 24,
                size: 3,
                tooltipId: 'timeUse',
                tooltip: Traduce('timeUseAfterValidaton')
            },
            {
                name: 'timeCancel',
                type: FieldType.Number,
                rules: rules()
                    .number()
                    .integer(),
                defaultValue: 0,
                size: 3,
                tooltipId: 'timeCancel',
                tooltip: Traduce('timeMaxCancelTicket')
            },
            {
                name: 'capacity',
                type: FieldType.Number,
                rules: rules().integer(),
                size: 2,
                tooltipId: 'capacity',
                tooltip: Traduce('capacity')
            },
            {
                name: 'units',
                type: FieldType.Number,
                rules: rules().integer(),
                size: 2,
                tooltipId: 'units',
                tooltip: Traduce('unitsTooltip')
            },
            {
                name: 'unitName',
                type: FieldType.Text,
                rules: rules().string(),
                size: 2,
                tooltipId: 'unitName',
                tooltip: Traduce('unitNameTooltip'),
                defaultValue: 'unit'
            },
            {
                name: 'webExpiration',
                column: 'webExpiration',
                type: FieldType.Number,
                rules: rules()
                    .number()
                    .integer(),
                size: 4,
                tooltipId: 'webExpiration',
                tooltip: Traduce('webExpirationMessage')
            },
            {
                name: 'valueMaxToReserve',
                column: 'valueMaxToReserve',
                type: FieldType.Number,
                rules: rules()
                    .number()
                    .integer(),
                size: 2,
                tooltipId: 'valueMaxToReserve',
                tooltip: Traduce('valueMaxToReserveTooltip')
            },
            {
                name: 'dateMaxToReserve',
                column: 'dateMaxToReserve',
                type: FieldType.Date,
                size: 2,
                mode: 'dp-below',
                // opened: true,
                tooltipId: 'dateMaxToReserve',
                tooltip: Traduce('dateMaxToReserveTooltip'),
            },
            {
                name: 'typeMaxToReserve',
                column: 'typeMaxToReserve',
                type: FieldType.Select,
                rules: rules().string(),
                options: ['byDays', 'byMonth', 'byDate'].map(function (item) {
                    return {
                        name: Traduce(item),
                        value: item
                    };
                }),
                tooltipId: 'typeMaxToReserve',
                tooltip: Traduce('typeMaxToReserveTooltip'),
                size: 3
            },
            {
                name: 'valueMaxBeforeReserve',
                column: 'valueMaxBeforeReserve',
                type: FieldType.Number,
                rules: rules()
                    .number()
                    .integer(),
                size: 2,
                tooltipId: 'valueMaxBeforeReserve',
                tooltip: Traduce('valueMaxBeforeReserveTooltip')
            },
            {
                name: 'typeMaxBeforeReserve',
                column: 'typeMaxBeforeReserve',
                type: FieldType.Select,
                rules: rules().string(),
                options: ['byHours', 'byDays'].map(function (item) {
                    return {
                        name: Traduce(item),
                        value: item
                    };
                }),
                tooltipId: 'typeMaxBeforeReserve',
                tooltip: Traduce('typeMaxBeforeReserveTooltip'),
                size: 3
            },
            {
                name: 'additionalrequiredinformation',
                type: FieldType.Checkbox,
                rules: rules().boolean(),
                size: 5,
                defaultValue: false,
                tooltipId: 'additionalrequiredinformation',
                tooltip: Traduce('additionalrequiredinformationTooltip')
            },
            {
                name: 'disableWeb',
                type: FieldType.Checkbox,
                rules: rules().boolean(),
                size: 3,
                defaultValue: false,
                tooltipId: 'disableWeb',
                tooltip: Traduce('disableWebTooltip')
            },
            {
                name: 'disableVirtual',
                type: FieldType.Checkbox,
                rules: rules().boolean(),
                size: 3,
                defaultValue: false,
                tooltipId: 'disableVirtual',
                tooltip: Traduce('disableVirtualTooltip')
            },
            {
                name: 'disableTerminal',
                type: FieldType.Checkbox,
                rules: rules().boolean(),
                size: 3,
                defaultValue: false,
                tooltipId: 'disableTerminal',
                tooltip: Traduce('disableTerminalTooltip')
            },
            {
                name: 'emails',
                type: FieldType.Text,
                tooltipId: 'emails',
                tooltip: Traduce('emailsToSend'),
                rules: rules().arrayEmailsComma(),
                size: 10
            },
            {
                name: 'aditionalInfo',
                type: FieldType.Text,
                rules: rules().string(),
                size: 10,
                tooltipId: 'aditionalInfo',
                tooltip: Traduce('aditionalInfo')
            },
            {
                name: 'description',
                type: FieldType.TextArea,
                rules: rules().string().max(255),
                size: 10,
                tooltipId: 'description',
                tooltip: Traduce('serviceDescription')
            },
            {
                name: 'image',
                type: FieldType.Image,
                accept: 'image/jpeg',
                footer: 'Imagen, formato jpg\n recomendado 150x150px',
                size: 10
            }
            /*{
              name: 'withVehicle',
              type: FieldType.Checkbox,
              rules: rules()
                .boolean(),
              size: 10,
              defaultValue: true,
              tooltipId: 'withVehicle',
              tooltip: Traduce('serviceWithVehiculo')
            },*/ /*
            {
              name: 'horasIda',
              /!*column: 'horasIda',*!/
              type: FieldType.MultiSelect,
              options: this.horasIdaOptions,
              tooltipId: 'horasIda',
              tooltip: Traduce('departureTime'),
              size: 5
            },*/
            /*{
              name: 'vehicles',
              type: FieldType.MultiSelect,
              options: this.vehiclesOptions,
              tooltipId: 'vehicles',
              tooltip: Traduce('vehicles'),
              size: 5
            },*/
            /*{
              name: 'horasVuelta',
              /!*column: 'horasIda',*!/
              type: FieldType.MultiSelect,
              options: this.horasVueltaOptions,
              tooltip: 'Horarios de vuelta',
              size: 5
            },*/
            /*{
              name: 'minToPay',
              column: 'minToPay',
              type: FieldType.Number,
              rules: rules().number(),
              defaultValue: 0,
              size: 2,
              tooltipId: 'minToPay',
              tooltip: Traduce('minToPay')
            },*/
            /*{
              name: 'typeMinToPay',
              column: 'typeMinToPay',
              type: FieldType.Select,
              rules: rules().string(),
              options: ['percentage', 'fix'].map(item => {
                return {
                  name: Traduce(item),
                  value: item
                }
              }),
              size: 2
            },*/
            /*{
              name: 'serviceDuration',
              type: FieldType.Number,
              rules: rules()
                .integer(),
              size: 2,
              tooltipId: 'serviceDuration',
              tooltip: Traduce('serviceDurationTooltip')
            },*/
            /*{
              name: 'dateMaxBeforeReserve',
              column: 'dateMaxBeforeReserve',
              type: FieldType.Date,
              size: 2,
              mode: 'dp-below',
              // opened: true,
              tooltipId: 'dateMaxBeforeReserve',
              tooltip: Traduce('dateMaxBeforeReserveTooltip'),
            },*/
            /*{
              name: 'minToPayWeb',
              type: FieldType.Number,
              rules: rules()
                .number()
                .integer(),
              size: 2,
              tooltipId: 'minToPayWeb',
              tooltip: Traduce('minToPayWebTooltip')
            },*/ /*
            {
              name: 'icon',
              type: FieldType.Icon,
              rules: rules().string(),
              size: 12,
              icons: Iconos
            },*/
        ];
        _this.handleDuplicate = function () {
            history.push("/stretches/duplicate/".concat(_this.props.stretch.id), _this.props.stretch);
        };
        return _this;
    }
    StretchesForm.prototype.render = function () {
        /*this.prices = [...this.prices, ...[
          {name: 'Discapacitado',
            type: FieldType.Text,
            rules: rules().number(),
            size: 1
          }
          ]
        ]*/
        // console.log('this.categoryFields', this.categoryFields)
        // console.log('StretchesForm - render - this.fields', this.fields)
        var _a = this.props, stretch = _a.stretch, _b = _a.reactstrap, reactstrap = _b === void 0 ? true : _b;
        /*if (stretch) {
          stretch.hora = {hours: stretch.hours, minutes: stretch.minutes}
        }*/
        // console.log('StretchesForm - render - stretchForm', stretch)
        var stretches = this.props.store.stretches;
        var collaboratorPriceFields = this.props.stretch
            ? this.collaboratorPriceFields(false)
            : {};
        var afiliatePriceFields = this.props.stretch
            ? this.afiliatePriceFields(false)
            : {};
        var collaboratorVueltaPriceFields = this.props.stretch
            ? this.collaboratorPriceFields(true)
            : {};
        var afiliateVueltaPriceFields = this.props.stretch
            ? this.afiliatePriceFields(true)
            : {};
        // console.log('StretchForm - render - collaboratorPriceFields: ', collaboratorPriceFields)
        /*console.log('this.continue: ', StretchesForm.continue)
        if (stretch && !stretch.marketing && !StretchesForm.continue) {
          const accept = confirm('Esta experiencia no tiene valores para etiquetas de marketing, ¿desea porner por defecto?')
          if (accept) {
            this.props.store.marketingStore.createDefault({data: {owner_ids: [stretch.id]}}).then(result => {
              StretchesForm.continue = true
              return history.push(`/stretches/${stretch.id}`)
            }).catch(error => {
              console.log('catch error: ', error)
              StretchesForm.continue = true
              return history.push(`/stretches/${stretch.id}`)
            })
            return <div>
              poniendo por defecto.....
            </div>
          }
        }*/
        return (React.createElement(React.Fragment, null,
            !this.props.duplicate && this.props.stretch && (React.createElement(Button, { onClick: this.handleDuplicate }, Traduce('duplicate'))),
            React.createElement(StretchesFormulario, { reactstrap: reactstrap, duplicate: this.props.duplicate, 
                /*delete={this.props.match.params.id}*/
                loading: ['post@stretch/', 'put@stretch/', 'patch@stretch/'], fields: this.fields, values: stretch, store: stretches, priceFields: this.priceFields, vueltaPriceFields: this.vueltaPriceFields, collaboratorPriceFields: collaboratorPriceFields, afiliatePriceFields: afiliatePriceFields, collaboratorVueltaPriceFields: collaboratorVueltaPriceFields, afiliateVueltaPriceFields: afiliateVueltaPriceFields, stores: this.props.store, extras: this.props.extras, collaborators: this.props.collaborators, afiliates: this.props.afiliates, passengerCategories: this.props.passengerCategories })));
    };
    StretchesForm.continue = false;
    StretchesForm = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.store.passengerCategories.read().then(function (passengerCategories) {
                // console.log('finalizado passengerCategories read')
                return { passengerCategories: passengerCategories };
            }),
            props.match.params.id
                ? props
                    .store.stretches.read(props.match.params.id)
                    .then(function (stretch) {
                    if (props.duplicate) {
                        delete stretch.id;
                    }
                    return { stretch: stretch };
                })
                : undefined,
            props.store.operationLines.read().then(function (operationLines) { return ({ operationLines: operationLines }); }),
            props.store.taxes.read().then(function (taxes) { return ({ taxes: taxes }); }),
            props.store.scheduleStore.read().then(function (schedules) { return ({ schedules: schedules }); }),
            props.store.headboardStore.read().then(function (headboards) { return ({ headboards: headboards }); }),
            props.store.extraStore.read().then(function (extras) { return ({ extras: extras }); }),
            props.store.receipLayouts.read().then(function (receiptLayouts) { return ({ receiptLayouts: receiptLayouts }); }),
            props.store.vehiclesStore.read().then(function (vehicles) { return ({ vehicles: vehicles }); }),
            props.store.moneysStore.read().then(function (moneys) {
                var primaryMoney = moneys.find(function (money) { return money.primary; });
                return { money: primaryMoney };
            }),
            props.store.collaboratorStore.read().then(function (collaborators) { return ({ collaborators: collaborators }); }),
            props.store.afiliateStore.read().then(function (afiliates) { return ({ afiliates: afiliates }); })
        ]; })
    ], StretchesForm);
    return StretchesForm;
}(Component));
export default StretchesForm;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stretches/container/StretchesForm.tsx
// module id = 1263
// module chunks = 0